var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@mademine/components';
import { I18n } from '@mademine/utils';
import { ReactComponent as IconClose } from '../../assets/icon-arrow-bold-close.svg';
import { useData } from '../../hooks/useData';
import React from 'react';
var TextInputEdit = function (_a) {
    var language = _a.language, guideImage = _a.guideImage, initialTextInputSettings = _a.textInputSettings, onClose = _a.onClose, onComfirm = _a.onComfirm;
    var backupGuideImage = 'https://assets.sunzi.cool/mini-me/t-shirt/20230718-181129.jpeg';
    var _b = useData(), inputTextDataText = _b.inputTextDataText, setInputTextDataText = _b.setInputTextDataText;
    var _c = useState(initialTextInputSettings), textInputSettings = _c[0], setTextInputSettings = _c[1];
    var _d = useState(false), enableConfirm = _d[0], setEnableConfirm = _d[1];
    var checkInputValidity = function (inputArray) {
        if (inputArray) {
            var isValid = true;
            for (var _i = 0, inputArray_1 = inputArray; _i < inputArray_1.length; _i++) {
                var item = inputArray_1[_i];
                if (!item.value) {
                    isValid = false;
                    break;
                }
            }
            setEnableConfirm(isValid);
        }
    };
    useEffect(function () {
        checkInputValidity(inputTextDataText);
    }, []);
    var checkInputOverflow = function (inputArray, id, userInput) {
        var targetItem = inputArray.find(function (item) { return item.id === id; });
        if (targetItem) {
            return userInput.length <= targetItem.maxLength;
        }
        return false;
    };
    var hanldeChangeTextValue = function (value, id) {
        if (!checkInputOverflow(textInputSettings, id, value))
            return;
        var newTexts = __spreadArray([], textInputSettings, true);
        var newTextIndex = newTexts.findIndex(function (item) { return item.id === id; });
        if (newTextIndex !== -1) {
            newTexts[newTextIndex].value = value;
            var newTextData = __spreadArray([], newTexts, true);
            setTextInputSettings(newTextData);
            var textInputResult = newTextData === null || newTextData === void 0 ? void 0 : newTextData.map(function (inputSetting) {
                var _a;
                return ({
                    title: (_a = inputSetting === null || inputSetting === void 0 ? void 0 : inputSetting.title) === null || _a === void 0 ? void 0 : _a.en_US,
                    value: inputSetting.value,
                    font: inputSetting.font
                });
            });
            setInputTextDataText(textInputResult);
        }
        checkInputValidity(textInputSettings);
    };
    var handleSave = function () {
        checkInputValidity(textInputSettings);
        if (!enableConfirm)
            return;
        onComfirm();
    };
    return (_jsxs("div", { className: "_sz-bottom-0 _sz-absolute _sz-max-h-inputDrawerHeight  _sz-rounded-t-2xl _sz-bg-white _sz-p-5 _sz-pb-9 sm:_sz-pb-5 _sz-overflow-y-auto ", children: [_jsx("div", { className: "_sz-absolute _sz-top-0 _sz-left-0 _sz-m-3 _sz-cursor-pointer _sz-p-2", onClick: onClose, children: _jsx(Icon, { color: "#191919", size: 24, children: _jsx(IconClose, {}) }) }), _jsx("div", { className: " _sz-mt-11 _sz-mb-5  _sz-aspect-[1.59] _sz-w-full _sz-rounded-xl _sz-border _sz-border-solid _sz-border-[rgba(0,0,0,0.06)] _sz-p-2", children: _jsx("img", { className: " _sz-h-full _sz-w-full _sz-rounded-lg _sz-object-cover", src: guideImage && guideImage[textInputSettings.length - 1]
                        ? guideImage[textInputSettings.length - 1]
                        : backupGuideImage, alt: "preview" }) }), textInputSettings &&
                textInputSettings.map(function (inputItem) {
                    var _a, _b;
                    return (_jsxs(React.Fragment, { children: [_jsx("h1", { className: " _sz-mx-2 _sz-mb-2 _sz-mt-0 _sz-text-sm _sz-font-semibold _sz-leading-[22px]", children: ((_a = inputItem === null || inputItem === void 0 ? void 0 : inputItem.title) === null || _a === void 0 ? void 0 : _a["".concat(language)])
                                    ? inputItem.title["".concat(language)]
                                    : I18n.format('custom.text.on.clothes') }), _jsxs("div", { className: " _sz-relative _sz-overflow-hidden _sz-rounded-lg _sz-border _sz-border-solid _sz-border-[rgba(0,0,0,0.16)] _sz-mb-5 last-of-type:_sz-mb-0", children: [_jsx("textarea", { rows: 1, placeholder: ((_b = inputItem === null || inputItem === void 0 ? void 0 : inputItem.placeHolder) === null || _b === void 0 ? void 0 : _b["".concat(language)])
                                            ? inputItem.placeHolder["".concat(language)]
                                            : I18n.format('text.placeholder'), className: " _sz-w-full _sz-resize-none  _sz-border-none _sz-bg-white _sz-p-4 _sz-pr-[42px] _sz-text-base _sz-text-black _sz-outline-none", value: inputItem.value, onChange: function (e) {
                                            return hanldeChangeTextValue(e.target.value, inputItem.id);
                                        } }), _jsx("span", { className: " _sz-absolute _sz-right-4 _sz-bottom-4 _sz-text-sm _sz-leading-[22px] _sz-text-[rgba(0,0,0,0.48)]", children: "".concat(inputItem.value.length, "/").concat(inputItem.maxLength) })] })] }, inputItem.id));
                }), _jsx("button", { type: "button", className: classNames('_sz-mt-4 _sz-h-13 _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white', {
                    '!_sz-bg-[rgba(0,0,0,0.16)] !_sz-cursor-not-allowed _sz-touch-none': enableConfirm == false
                }), onClick: handleSave, children: I18n.format('pass.edit') })] }));
};
export default TextInputEdit;
